import { LifestyleCategoriesPageTemplateProps } from "./template";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useGetLifestyleCategories } from "@queries";
import { LSACategory } from "../../../../types";

export const useLifestyleCategoriesPage = (): LifestyleCategoriesPageTemplateProps => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedCategories, setSelectedCategories] = useState<LSACategory[]>([]);
    const [lifestyleGroupName, setLifestyleGroupName] = useState<string>("");

    const { lifestyleCategories, getLifestyleCategories, isLoading: isLoadingCategories } = useGetLifestyleCategories();

    // Here we will need to get the categories from the backend once the queries are added
    useEffect(() => {
        getLifestyleCategories();
    }, []);

    // Restore data from navigation state when returning to this page
    useEffect(() => {
        if (location.state?.selectedCategories) {
            setSelectedCategories(location.state.selectedCategories);
        }
        if (location.state?.lifestyleGroupName) {
            setLifestyleGroupName(location.state.lifestyleGroupName);
        }
    }, [location.state]);

    const navigateToPage = (to: string) => {
        navigate(to);
    }

    const onReturnPressed = () => {
        // Pass data back to main page
        navigate("/dashboard/lifestyle/main", {
            state: { 
                selectedCategories,
                lifestyleGroupName
            }
        });
    }

    const onToggleCategory = (category: LSACategory) => {
        setSelectedCategories(prev => {
            const isSelected = prev.some(selected => selected.id === category.id);
            if (isSelected) {
                return prev.filter(cat => cat.id !== category.id);
            } else {
                return [...prev, category];
            }
        });
    }

    const onSelectAllCategories = () => {
        setSelectedCategories(() => lifestyleCategories ? [...lifestyleCategories] : []);
    }

    const onContinue = () => {
        // Navigate to the next step (rules page) with all data
        navigate("/dashboard/lifestyle/rules", {
            state: { 
                selectedCategories,
                lifestyleGroupName
            }
        });
    }

    const onLifestyleGroupNameChange = (name: string) => {
        setLifestyleGroupName(name);
    }

    return {
        navigateToPage,
        onReturnPressed,
        selectedCategories,
        onToggleCategory,
        onContinue,
        lifestyleGroupName,
        onLifestyleGroupNameChange,
        lifestyleCategories: lifestyleCategories || [],
        isLoadingCategories,
        onSelectAllCategories
    }
} 
